import { useState, useContext, useEffect } from "react";
import {
  Button,
  Grid,
  Typography,
  Dialog,
  CircularProgress,
  Box,
  DialogTitle,
  DialogContentText,
  DialogContent,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";

interface IProps {
  open: boolean;
  onClose: () => void;
  selectedOrg: any;
  handleFetchOrganizations: () => void;
}

const ConfirmDeleteModal = ({
  open,
  onClose,
  handleFetchOrganizations,
  selectedOrg,
}: IProps) => {
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [deleteText, setDeleteText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDeleteOrganization = async () => {
    setLoading(true);
    try {
      await Http.deleteReq({
        url: `/api/v2/organizations/${selectedOrg.orgId}`,
        state: userInfo,
      });

      handleFetchOrganizations();

      onClose();
    } catch (err) {
      appLogger.error({
        errObj: {
          method: "handleDeleteOrganization",
          component: "ManageOrganizations",
          fileName: "ManageOrganizations.tsx",
          err: err,
        },
      });
      setLoading(false);
    }
  };

  return (
    <Dialog
      className="delete-popup text-center"
      onClose={onClose}
      open={open}
      maxWidth="sm"
    >
      <Box
        sx={{ width: "100%" }}
        className={loading ? "delete-form-wrap loader" : "delete-form-wrap"}
      >
        <i className="icon-delete-1 popup-icon" />
        <DialogTitle>Delete Warning!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography className="info">
              <span>
                This operation will delete the {selectedOrg?.name} permanently.
                All created accounts, products, settings will be gone, this
                cannot be undone.
              </span>
            </Typography>
            <Typography className="confirm-txt">
              Type “delete” to confirm
            </Typography>
            <Box className="delete-form">
              <FormControl className="custom-select" fullWidth>
                <OutlinedInput
                  type="text"
                  value={deleteText}
                  onChange={(e) => setDeleteText(e.target.value)}
                  label=""
                  endAdornment={
                    <InputAdornment position="end">
                      {deleteText.length > 0 && (
                        <IconButton
                          aria-label="search icon"
                          edge="end"
                          onClick={() => setDeleteText("")}
                        >
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Button
                variant="contained"
                disabled={deleteText !== "delete"}
                onClick={handleDeleteOrganization}
              >
                delete
              </Button>
              <Button variant="text" onClick={onClose}>
                cancel
              </Button>
            </Box>
          </DialogContentText>
        </DialogContent>
      </Box>
    </Dialog>

    // <Dialog open={open} onClose={onClose} title="Delete knowledgebase">
    //   <Grid
    //     container
    //     sx={{
    //       padding: "10px",
    //     }}
    //   >
    //     <Grid item xs={12}>
    //       <Typography
    //         sx={{
    //           fontWeight: 500,
    //           fontSize: "18px",
    //         }}
    //       >
    //         Delete Organization
    //       </Typography>
    //     </Grid>
    //   </Grid>
    //   {loading && (
    //     <Grid
    //       container
    //       justifyContent="center"
    //       alignItems="center"
    //       sx={{
    //         minWidth: "500px",
    //         minHeight: "150px",
    //       }}
    //     >
    //       <CircularProgress size={30} />
    //     </Grid>
    //   )}
    //   {!loading && (
    //     <Grid
    //       container
    //       justifyContent="center"
    //       sx={{
    //         padding: "30px",
    //       }}
    //     >
    //       <Grid item xs={12} textAlign="center">
    //         <Typography
    //           sx={{
    //             fontSize: "16px",
    //           }}
    //         >
    //           All created accounts, products, settings will be gone. this cannot
    //           be undone.
    //         </Typography>
    //         <Typography
    //           sx={{
    //             marginTop: "10px",
    //             fontSize: "16px",
    //           }}
    //         >
    //           Are you sure you want to delete it?
    //         </Typography>
    //       </Grid>
    //       <Grid
    //         container
    //         justifyContent="center"
    //         gap="15px"
    //         item
    //         xs={12}
    //         mt="15px"
    //       >
    //         <Button variant="outlined" onClick={onClose}>
    //           Cancel
    //         </Button>
    //         <Button
    //           variant="contained"
    //           onClick={handleDeleteOrganization}
    //           disabled={loading}
    //         >
    //           Confirm
    //         </Button>
    //       </Grid>
    //     </Grid>
    //   )}
    // </Dialog>
  );
};

export default ConfirmDeleteModal;
